import { Tag } from 'antd';

const renderNestedData = (gtvType, key) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-around',
      flexDirection: 'column',
      alignItems: 'center',
      rowGap: '20px'
    }}
  >
    {Object.keys(gtvType).map((gtvKey) => (
      <div key={`${gtvKey}-${key}`}>
        {key === 'transaction_success_rate' ? `${gtvType[gtvKey][key]} %` : gtvType[gtvKey][key]}
      </div>
    ))}
  </div>
);

const renderHeader = (gtvType) => (
  <div
    style={{
      rowGap: '20px',
      display: 'flex',
      justifyContent: 'space-around',
      flexDirection: 'column',
      alignItems: 'flex-start'
    }}
  >
    {Object.keys(gtvType).map((gtvKey) => (
      <div style={{ fontWeight: 'bold' }} key={gtvKey}>
        <Tag color="purple">{gtvKey}</Tag>
      </div>
    ))}
  </div>
);

const columnTitles = [
  { title: 'Live Merchant', key: 'live' },
  { title: 'KYC Initiated', key: 'kyc_initiated' },
  { title: 'KYC Completed', key: 'kyc_completed' },
  { title: 'KYC Rejected', key: 'kyc_rejected' },
  { title: 'Total Merchant', key: 'total_merchant' },
  { title: 'Channel UPI', key: 'channel_upi' },
  { title: 'Channel DC', key: 'channel_dc' },
  { title: 'Channel CC', key: 'channel_cc' },
  { title: 'Channel NB', key: 'channel_nb' },
  { title: 'Transacting', key: 'transacting' },
  { title: 'Transaction Attempt', key: 'transaction_attempt' },
  { title: 'Transaction Successfull %', key: 'transaction_success_rate', sufix: '%' },
  { title: 'Success Count', key: 'success' },
  { title: 'Failure Count', key: 'failure' },
  { title: 'Dropped Count', key: 'dropped' }
];

const getGtvColumns = (label, key, useCustomRendering) => {
  return [
    {
      title: 'BO State',
      dataIndex: 'state',
      key: 'state',
      fixed: 'left',
      render: (text) => <span style={{ fontWeight: 'bold' }}>{text}</span>
    },
    ...(useCustomRendering
      ? [
          {
            title: label,
            dataIndex: [key],
            key,
            fixed: 'left',
            render: (gtvType) => renderHeader(gtvType, key)
          }
        ]
      : []),
    ...columnTitles.map(({ title, key: colKey }) => ({
      title,
      dataIndex: useCustomRendering ? [key] : [key, colKey],
      key: colKey,
      render: (gtvType) =>
        useCustomRendering ? (
          renderNestedData(gtvType, colKey)
        ) : (
          <span
            style={{
              display: 'flex',
              justifyContent: 'space-around',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            {gtvType}
          </span>
        )
    }))
  ];
};

export default getGtvColumns;
